import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-ip-tab',
  templateUrl: './ip-tab.component.html',
  styleUrls: ['./ip-tab.component.scss'],
})
export class IpTabComponent implements OnInit {
  @Input()
  title!: string;

  @Input()
  selected = false;

  constructor() {}

  ngOnInit(): void {}
}
